import { Box, Link } from "@chakra-ui/react";
import Marquee from "react-fast-marquee";
import { t, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { useRouter } from 'next/router';
import React, { useEffect, useState, useRef } from "react";
import { useRequest } from "../contexts/request";

const showAnnouncement = true;
const Announcement = () => {
  if (!showAnnouncement) {
    return null;
  }
  const router = useRouter();
  const { pathname } = router;
  const { _, i18n } = useLingui();

  const { get } = useRequest();

  const [announcement, setAnnouncement] = useState("");
  const [link, setLink] = useState("#");
  const requestRef = useRef(0);

  const fetchAnnouncement = async () => {
    try {
      const currency = i18n.locale === 'en' ? 'PHP' : i18n.locale === 'ja' ? 'JPY' : 'IDR';
      const requestId = ++requestRef.current;
      const { json: { data } } = await get(`running-text?currency=${currency}`);
      if (requestId === requestRef.current) {
        setAnnouncement(data.running_text);
        setLink(data.link || "#");
      }
    } catch (error) {
      console.error('Failed to fetch announcement:', error);
    }
  };

  useEffect(() => {
    if (i18n.locale) {
      fetchAnnouncement();
    }
  }, [i18n.locale]);

  return (
    <Box w="100vw" bgColor="#faae2b">
      {announcement && (
        link && link !== "#" ? (
          <Link href={link}>
            <Marquee gradient={false} speed={50}>
              <Box w="max-content" ml={5}>
                {announcement}
              </Box>
            </Marquee>
          </Link>
        ) : (
          <Marquee gradient={false} speed={50}>
            <Box w="max-content" ml={5}>
              {announcement}
            </Box>
          </Marquee>
        )
      )}
    </Box>
  );
};

export { Announcement };
